(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  // Pin a stable viewport-height unit for full-screen / custom hero heights.
  //
  // The CSS uses `calc(var(--hero-stable-vh) * N)` instead of `Nsvh`. `svh` is supposed to
  // stay fixed while a mobile browser's dynamic toolbar shows and hides, but Firefox Android
  // recomputes it during the toolbar animation — resizing this top-of-page section and jolting
  // the whole page. We freeze the unit to one hundredth of the viewport height and only
  // re-measure it on genuine width / orientation changes; a toolbar toggle changes height
  // only, so the hero holds its size through it.
  (() => {
    const root = document.documentElement;
    const pin = () => root.style.setProperty('--hero-stable-vh', `${window.innerHeight / 100}px`);
    pin();

    let lastWidth = window.innerWidth;
    window.addEventListener(
      'resize',
      () => {
        // Width unchanged means a height-only resize — a toolbar toggle, not a real relayout.
        // Re-measuring there is exactly the jolt we are removing, so skip it.
        if (window.innerWidth === lastWidth) return;
        lastWidth = window.innerWidth;
        pin();
      },
      { passive: true }
    );
    window.addEventListener('orientationchange', pin, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-progress"] && !Shopify.designMode) return;
  try {
    
  class ScrollProgress extends HTMLElement {
    constructor() {
      super();
      this.bar = null;
      this.ticking = false;
      this.footerHeight = 0;
      this.onScroll = this.onScroll.bind(this);
      this.update = this.update.bind(this);
      this.measure = this.measure.bind(this);
    }

    connectedCallback() {
      this.bar = this.querySelector('.scroll-progress__bar');
      this.measure();
      this.update();
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.measure, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.measure);
    }

    measure() {
      const footer = document.querySelector('footer');
      this.footerHeight = footer ? footer.offsetHeight : 0;
      this.update();
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(this.update);
    }

    update() {
      this.ticking = false;
      // Page height excludes the footer so the bar reaches 100% as the footer appears.
      const maxScroll =
        document.documentElement.scrollHeight - window.innerHeight - this.footerHeight;
      const progress = maxScroll > 0 ? Math.min(window.scrollY / maxScroll, 1) : 0;
      if (this.bar) this.bar.style.transform = `scaleX(${progress})`;
    }
  }

  if (!customElements.get('scroll-progress')) {
    customElements.define('scroll-progress', ScrollProgress);
  }

  } catch(e) { console.error(e); }
})();
})();
